var map = {
	"./Conveyor-1200-COMPRESSED.gif": "118c",
	"./Forklift-warehouse-2-1200-COMPRESSED.gif": "69f4",
	"./Lecturer-2-800-COMPRESSED.gif": "508b",
	"./Man-gesturing-and-forklift-2-1200-COMPRESSED.gif": "e0e9",
	"./Man-walking-2-1200-COMPRESSED-CROPPED.gif": "601f",
	"./Pancake-flip-2-1200-COMPRESSED-CROPPED.gif": "fd98",
	"./Truck-reversing-2-1000-COMPRESSED-CROPPED.gif": "cdf6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b42";